import Link from "next/link"
import { IconSVG, IconVariant, LogoSVG } from "../logo"

// Left section: logo
export const NavbarLogo = () => {
  return (
    <>
      <Link href="/">
        <LogoSVG className="h-auto w-36 text-brand dark:text-default transition-colors duration-300 hidden sm:block" />
        <IconSVG
          className="h-9 w-9 block sm:hidden"
          variant={IconVariant.BRAND_GRADIENT}
        />
      </Link>
    </>
  )
}
